export default "__VITE_PUBLIC_ASSET__2dfe34fb__"